import React, { Component } from 'react'
import ReactGA from 'react-ga'

import Ball from './components/Ball'
import LoginBox from './components/LoginBox'
import utils from './lib/utils'
import Joystick from './components/Joystick'
import Ranking from './components/Ranking'
import ZenSettings from './components/ZenSettings'
import HomeButton from './components/HomeButton'
import HallOfFame from './components/HallOfFame'

import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import FullscreenRoundedIcon from '@material-ui/icons/FullscreenRounded';
import FullscreenExitRoundedIcon from '@material-ui/icons/FullscreenExitRounded';

import './App.css';

import {nextHof as fakeNextHof, hofData as fakeHofData} from './fakeData';
const useFakeHofData = false; // set to true for testing if no data from backend is available

if(process.env.NODE_ENV !== "development"){
  // do not log in dev
  ReactGA.initialize('UA-85767831-1');
  const pathname = window.location.pathname || ""
  const search = window.location.search || ""
  const extraInfo = pathname || search ? ` (${pathname}${search})` : ""
  ReactGA.set({ page: "zen-balls-app" + extraInfo});
  ReactGA.pageview("zen-balls-app" + extraInfo);
}

const io = require('socket.io-client');
const feathers = require('@feathersjs/feathers');
const socketio = require('@feathersjs/socketio-client');


const host = process.env.NODE_ENV === 'production' ? "dev-ze.rocks" : "localhost:4040" 
//const host = "localhost:8080" // use this while testing production builds on localhost. The dev-ze page server must be running... 
const path = process.env.NODE_ENV === 'production' ? "/zen-balls-back/socket.io" : null
const socket = io(host, {path});
const client = feathers();
client.configure(socketio(socket));

export default class App extends Component {

  constructor() {
    super();
    this.state = {
      showLoginBox: true,
      player: {
        name: "Hans!",
        handle: "",
        link: "",
        image: false,
      },
      frameDimensions: { // note, those values will be (re)set on didMount/
        top: 0, 
        left: 0,
        height: 600,
        width: 400
      },
      scaling: false,
      updateInterval: 30,
      balls: [],
      clientBall: {
        x: 0,
        y: 0
      },
      showEverything: true,
      currentHighScore: {
        id: false,
        player: false,
        time: 0
      },
      currentHighScoreSec: 0,
      currentRanking: [],
      fullRanking: true,
      collapsedRanking: false,
      clientHighScore: 0,
      clientId: false,
      fullSettings: true,
      collapsedSettings: true,
      zenSettings: {
        zenMode: true,
        numSquares: 8, // additional number of balls that contribute to the zen background. (current user ball always is included)
        dynamicSquareSize: true,
        highScoreSecUpdateInterval: 3,
        animatedHof: true,
        showMouseLine: true
      },
      validKeys: ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown'],
      mouseControllEnabled: true,
      mouseControll: false,
      isTouchDevice: utils.isTouchDevice(),
      joystickAngle: false,
      isInFullScreen: false,
      fullHof: true,
      collapsedHof: false,
      nextHof: useFakeHofData ? fakeNextHof : false,
      hofData: useFakeHofData ? fakeHofData : false
    };

    this.ballsFrameRef = false
    
    this._checkConnection()
    this.checkConnectionHandle = setInterval(this._checkConnection, 2000) // every 2 seconds check if there are updates happening
    
    this.currentUserInteractions = 0 // to keep track of user interactions
    this.lastUserInteractions = 0
    if(process.env.NODE_ENV !== "development"){
      this.gaHandle = setInterval(this._logToGa, 240000) // every 4 minutes log to GA (to keep session alive)
    }

    this.mousePos = false
  }

  _logToGa = () => {

    let label = "user not active"
    if(this.currentUserInteractions !== this.lastUserInteractions){
      label = "user active" // user did some mouse/joystick/keyboard action in the last 4 minutes
    }
    
    ReactGA.event({
      category: "Zen-Balls",
      action: "simulation running",
      label,
      nonInteraction: true
    });

    this.lastUserInteractions = this.currentUserInteractions
  }

  _handleKeyDown = (event) => {
    const key = event.key
    if (this.state.validKeys.includes(key) && !this.state.showLoginBox) {
      event.preventDefault()
      client.io.emit('remote-controll', { event: 'down', key })
      this.currentUserInteractions =+ 1
    }
  }

  _handleKeyUp = (event) => {
    const key = event.key
    if (this.state.validKeys.includes(key) && !this.state.showLoginBox) {
      event.preventDefault()
      client.io.emit('remote-controll', { event: 'up', key })
      this.currentUserInteractions =+ 1
    }
  }

  _scaleDimensions = (frameDimensions) => {
    // take the original bounding box and scale it to the current balls frame
    // Note, currently I keep the aspect ratio constant, so x and y are the same...

    const originalHeight = 600
    const originalWidth = 800
    const currentHeight = frameDimensions.height
    const currentWidth = frameDimensions.width

    return {
      y: currentHeight / originalHeight,
      x: currentWidth / originalWidth
    }
  }

  _setBallsFrameDimensions = () => {
    const frameDimensions = this.ballsFrameRef.getBoundingClientRect()
    const scaling = this._scaleDimensions(frameDimensions)

    this.setState({
      frameDimensions,
      scaling
    })
  }

  _handleResize = () => {
    this._setBallsFrameDimensions()
  }

  _handleMouseMove = (event) => {

    let clientX = event.clientX
    let clientY = event.clientY
    if (event.type === "touchmove" && event.changedTouches && event.changedTouches[0]) {
      clientX = event.changedTouches[0].clientX
      clientY = event.changedTouches[0].clientY
    }

    const frame = this.state.frameDimensions
    // mouse coordinates relative to balls frame
    const mouseX = clientX - frame.left
    const mouseY = clientY - frame.top

    this.currentUserInteractions += 1
    
    if (mouseX > 0 && mouseX < frame.width && mouseY > 0 && mouseY < frame.height) {
      // mouse is inside frame
      this.mousePos = {
        x: mouseX,
        y: mouseY
      }
    } else {
      // mouse is outside of frame
      this.mousePos = false
    }
  }

  _updateBalls = (data) => {

    const clientBall = data.balls.find(ball => ball.id === this.state.clientId)
    let clientHighScore = this.state.clientHighScore
    let mouseControll = false
    let mousePos = this.mousePos

    if (clientBall) {
      // update highscore
      if (clientBall.noCollisionTime > this.state.clientHighScore) {
        clientHighScore = clientBall.noCollisionTime
      }
      // update mouse angle
      if (this.mousePos && this.state.scaling) {
        const mouseX = this.mousePos.x / this.state.scaling.x
        const mouseY = this.mousePos.y / this.state.scaling.y
        const angle = Math.atan2(mouseY - clientBall.y, mouseX - clientBall.x)
        mouseControll = angle / Math.PI * 180
      }
    }

    if(this.state.zenSettings.dynamicSquareSize){
      const currentHighScoreSec = data.currentHighScore.time/1000
        
      if(Math.abs(currentHighScoreSec - this.state.currentHighScoreSec) > this.state.zenSettings.highScoreSecUpdateInterval){
        this.setState({
          currentHighScoreSec: Math.round(currentHighScoreSec)
        })
      }
    }
    
    if(this.state.updateInterval !== data.updateInterval){
      this.setState({
        updateInterval: data.updateInterval
      })
    }

    this._checkConnection()

    this.setState({
      balls: data.balls,
      clientBall,
      currentHighScore: data.currentHighScore,
      currentRanking: data.currentRanking,
      clientHighScore,
      mouseControll,
      mousePos
    })
  }

  _toggleEverything = () => {

    this.setState({
      showEverything: !this.state.showEverything
    })

  }

  _isInFullscreen = () => {

    return (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)

  }

  _onFullscreenChange = (event) => {

    this.setState({
      isInFullScreen: this._isInFullscreen()
    })

  }

  _toggleFullscreen = () => {

    if(!this._isInFullscreen()){
      const root = document.querySelector('#root')
      if (root.requestFullscreen) {
        root.requestFullscreen({ navigationUI: "hide" }).then({}).catch(err => {
          console.log(`An error occurred while trying to switch into full-screen mode: ${err.message} (${err.name})`);
        });
      } else if (root.mozRequestFullScreen) {
        root.mozRequestFullScreen(); // could not find any information about the nagivationUI parameter
      } else if (root.webkitRequestFullscreen) {
        root.webkitRequestFullscreen(); // could not find any information about the nagivationUI parameter
      }
    }else{
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }

  }

  _checkConnection = () => {

    const now = new Date()

    if(now - this.lastUpdated > this.state.updateInterval*3){
      // the update took more than three times the current update interval
      this.setState({
        outOfSync: true
      })
    }else{
      this.setState({
        outOfSync: false
      })
    }

    this.lastUpdated = now
  }

  setPlayerAndStart = (player) => {

    this.setState({
      player: player,
      showLoginBox: false
    })

    client.io.emit('set-player', player)
  }

  updateJoystick = (angle) => {
    
    this.currentUserInteractions =+ 1
    
    this.setState({
      joystickAngle: angle
    })
  }

  toggleRanking = () => {
    // if full and not collapsed, change to part.
    // if part and not collapsed, collapse.
    // if part and collapsed, make it full.
    // else, decollapse
    // TODO: create one generic function for all the button toggeling
    // -> move it into the button comp??
    if(this.state.fullRanking && !this.state.collapsedRanking){
      this.setState({
        fullRanking: false
      })
    }else if(!this.state.fullRanking && !this.state.collapsedRanking){
      this.setState({
        collapsedRanking: true
      })
    }else if(!this.state.fullRanking && this.state.collapsedRanking){
      this.setState({
        fullRanking: true
      })
    }else{
      this.setState({
        collapsedRanking: false
      })
    }
  }

  toggleSettings = () => {
    // if full and not collapsed, change to part.
    // if part and not collapsed, collapse.
    // if part and collapsed, make it full.
    // else, decollapse
    // TODO: create one generic function for all the button toggeling
    // -> move it into the button comp??
    if(this.state.fullSettings && !this.state.collapsedSettings){
      this.setState({
        fullSettings: false
      })
    }else if(!this.state.fullSettings && !this.state.collapsedSettings){
      this.setState({
        collapsedSettings: true
      })
    }else if(!this.state.fullSettings && this.state.collapsedSettings){
      this.setState({
        fullSettings: true
      })
    }else{
      this.setState({
        collapsedSettings: false
      })
    }
  }

  setSetting = (setting) => {    
    this.setState({
      zenSettings: { ...this.state.zenSettings, ...setting }
    })
  }

  toggleHof = () => {
    // if full and not collapsed, change to part.
    // if part and not collapsed, collapse.
    // if part and collapsed, make it full.
    // else, decollapse
    // TODO: create one generic function for all the button toggeling
    // -> move it into the button comp??
    if(this.state.fullHof && !this.state.collapsedHof){
      this.setState({
        fullHof: false
      })
    }else if(!this.state.fullHof && !this.state.collapsedHof){
      this.setState({
        collapsedHof: true
      })
    }else if(!this.state.fullHof && this.state.collapsedHof){
      this.setState({
        fullHof: true
      })
    }else{
      this.setState({
        collapsedHof: false
      })
    }
  }

  componentDidMount() {

    client.io.on('connect', () => {
      console.log("connected, id: ", client.io.id)
      this.setState({ clientId: client.io.id })

      // request updated hof data
      client.io.emit('hof-update')
    })

    client.service('balls').on('balls-update', (data) => {
      this._updateBalls(data)
    })

    client.service('balls').on('hof-update', (data) => {
      // callback for the corresponding call and also for general hof updates
      this.setState({ 
        nextHof: data.nextHof,
        hofData: data.hofData 
      })
    })

    setTimeout(() => this._setBallsFrameDimensions(), 200) // not sure why, but I need this delay to get the real values :/

    document.addEventListener("keydown", this._handleKeyDown);
    document.addEventListener("keyup", this._handleKeyUp);
    document.addEventListener("mousemove", this._handleMouseMove);
    document.addEventListener("touchmove", this._handleMouseMove);
    window.addEventListener("resize", this._handleResize);

    document.addEventListener('fullscreenchange', this._onFullscreenChange, false);
    document.addEventListener('mozfullscreenchange', this._onFullscreenChange, false);
    document.addEventListener('MSFullscreenChange', this._onFullscreenChange, false);
    document.addEventListener('webkitfullscreenchange', this._onFullscreenChange, false);
  }

  componentWillUnmount() {

    document.removeEventListener("keydown", this._handleKeyDown);
    document.removeEventListener("keyup", this._handleKeyUp);
    document.removeEventListener("mousemove", this._handleMouseMove);
    document.removeEventListener("touchmove", this._handleMouseMove);
    window.removeEventListener("resize", this._handleResize);

    document.removeEventListener('fullscreenchange', this._onFullscreenChange, false);
    document.removeEventListener('mozfullscreenchange', this._onFullscreenChange, false);
    document.removeEventListener('MSFullscreenChange', this._onFullscreenChange, false);
    document.removeEventListener('webkitfullscreenchange', this._onFullscreenChange, false);
  }

  componentDidUpdate(prevProps, prevState) {
    
    // only send the mouse controll event to the server if it actually changed
    if (this.state.mouseControllEnabled && prevState.mouseControll !== this.state.mouseControll) {
      if (this.state.mouseControll) {
        client.io.emit('remote-controll', { event: 'mouseOn', angle: this.state.mouseControll })
      } else {
        client.io.emit('remote-controll', { event: 'mouseOff', angle: false })
      }
    }
    if (prevState.joystickAngle !== this.state.joystickAngle) {
      if (this.state.joystickAngle) {
        client.io.emit('remote-controll', { event: 'mouseOn', angle: this.state.joystickAngle })
      } else {
        client.io.emit('remote-controll', { event: 'mouseOff', angle: false })
      }
    }
  }

  render() {

    const collapsedSettings = !this.state.showEverything
      ? "fullyCollapsed"
      : this.state.collapsedSettings 
        ? "partlyCollapsed"
        : "notCollapsed"
    const collapsedRanking = !this.state.showEverything
      ? "fullyCollapsed"
      : this.state.collapsedRanking 
        ? "partlyCollapsed"
        : "notCollapsed"
    const collapsedHof = !this.state.showEverything
      ? "fullyCollapsed"
      : this.state.collapsedHof
        ? "partlyCollapsed"
        : "notCollapsed"

    return ([
      this.state.isTouchDevice &&
      <Joystick key="joystick" frameDimensions={this.state.frameDimensions} updateJoystick={this.updateJoystick} />,
      <div key="balls-frame" className="balls-frame" ref={el => this.ballsFrameRef = el}>
        {
          this.state.mousePos && !this.state.showLoginBox && this.state.zenSettings.showMouseLine &&
          <svg height={this.state.frameDimensions.height} width={this.state.frameDimensions.width} >
            <line x1={this.state.clientBall.x * this.state.scaling.x} y1={this.state.clientBall.y * this.state.scaling.y} x2={this.state.mousePos.x} y2={this.state.mousePos.y} style={{ stroke: "white", strokeWidth: 4, strokeOpacity: 0.06, strokeLinecap: "round" }} />
          </svg>
        }
        {
          this.state.scaling && this.state.balls.map((ball, index) => <Ball
            key={ball.id}
            scaling={this.state.scaling}
            ball={ball}
            currentBall={this.state.clientId === ball.id}
            hasHighScore={this.state.currentHighScore.id === ball.id}
            currentHighScoreSec={this.state.currentHighScoreSec}
            zenMode={this.state.zenSettings.zenMode && (index < this.state.zenSettings.numSquares || this.state.clientId === ball.id)}
            fullRanking={this.state.fullRanking}
            zenSettings={{dynamicSquareSize: this.state.zenSettings.dynamicSquareSize}}
          />)
        }
      </div>,
      <div key="everything-wrapper" className="everything-wrapper">
        <div  className="menu">
          <div key="menu-toggle" className="menu-item" onClick={this._toggleEverything}>{this.state.showEverything ? <KeyboardArrowUpRoundedIcon /> : <KeyboardArrowDownRoundedIcon />}</div>
          <HomeButton key="menu-home" />
          <div key="menu-fullscreen" className="menu-item" onClick={this._toggleFullscreen}>{this.state.isInFullScreen ? <FullscreenExitRoundedIcon /> : <FullscreenRoundedIcon />}</div>
        </div>
        <div className="everything">
          <Ranking key="ranking" currentRanking={this.state.currentRanking} clientId={this.state.clientId} fullRanking={this.state.fullRanking} toggleRanking={this.toggleRanking} collapsed={collapsedRanking}/>
          <HallOfFame key="hof" hofData={this.state.hofData} nextHof={this.state.nextHof} fullHof={this.state.fullHof} toggleHof={this.toggleHof} collapsed={collapsedHof} animated={this.state.zenSettings.animatedHof}/>
          <ZenSettings key="settings" settings={this.state.zenSettings} setSetting={this.setSetting} fullSettings={this.state.fullSettings} toggleSettings={this.toggleSettings} collapsed={collapsedSettings}/>
        </div>
      </div>,
      this.state.outOfSync &&
      <div key="outofsync-box" className="outofsync-box">
        Connection problem...
      </div>,
      this.state.showLoginBox &&
      <LoginBox key="lobo" setPlayerAndStart={this.setPlayerAndStart} />
    ]);
  }
}
